export const reducer = (prevState, action) => {
    switch (action.type) {
        case 'reset':
            return {
                id: action.components[0].id,
                message: action.components[0].message,
                padding: action.components[0].padding,
                rect: action.components[0].rect,
                copyConfigurations: action.components[0].copyConfigurations,
                hasNext: action.components.length > 1,
                hasBefore: false,
                counter: 0,
            };
        case 'next':
            if (!prevState.hasNext) { console.log('dont has next'); return prevState; }
            return {
                id: action.components[prevState.counter + 1].id,
                message: action.components[prevState.counter + 1].message,
                padding: action.components[prevState.counter + 1].padding,
                rect: action.components[prevState.counter + 1].rect,
                copyConfigurations: action.components[prevState.counter + 1].copyConfigurations,
                hasNext: action.components.length > prevState.counter + 2,
                hasBefore: true,
                counter: prevState.counter + 1,
            };
        case 'prev':
            if (!prevState.hasBefore) { console.log('dont has prev'); return prevState; }
            return {
                id: action.components[prevState.counter - 1].id,
                message: action.components[prevState.counter - 1].message,
                padding: action.components[prevState.counter - 1].padding,
                rect: action.components[prevState.counter - 1].rect,
                copyConfigurations: action.components[prevState.counter - 1].copyConfigurations,
                hasNext: true,
                hasBefore: prevState.counter - 1 > 0,
                counter: prevState.counter - 1,
            };
        default:
            console.log("Erro")
    }
}